module.exports = __webpack_public_path__ + "static/media/page-intro-img-1.ba48025b.png";